import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { CentralizedLagsGuideLines } from "../LagsSection/LagsGuidelines";
import { CentralizedLagsSection1 } from "../LagsSection/LagsSection1";
import { CentralizedLagsSection2 } from "../LagsSection/LagsSection2";
import { CentralizedLagsSection3 } from "../LagsSection/LagsSection3";
import { CentralizedLagsSteps } from "../LagsSection/LagsSteps";

export const CentralizedLags = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const travellersInfoCard = [
    {
      label: "Page Content",
      key: "centralizedLagsPageContent",
      children: <CentralizedLagsSection1 />,
    },
    {
      label: "Lags Steps",
      key: "centralizedLagsSteps",
      children: <CentralizedLagsSteps />,
    },
    {
      label: "Liquid Item Image",
      key: "centralizedLagsLiquidItemImage",
      children: <CentralizedLagsSection2 />,
    },
    {
      label: "Disclaimer Content",
      key: "centralizedLagsDisclaimerContent",
      children: <CentralizedLagsSection3 />,
    },
    // {
    //   label: "Guidelines Content",
    //   key: "centralizedLagsGuidelinesContent",
    //   children: <CentralizedLagsSection4 />
    // },
    {
      label: "Guidelines Content",
      key: "centralizedLagsGuidelinesContent",
      children: <CentralizedLagsGuideLines />,
    },
  ];

  return (
    // <ContentWrapper>
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
